import React, { Component } from "react";

import "./styles.css";

class TextEditorFunctionsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bold: false,
      italic: false,
      underline: false,

      componentStyle: {
        container: "literarte-text-editor-functions-menu",
        formattingMenu: "literarte-text-editor-formatting-menu",
        formattingButton: "literarte-text-editor-formatting-button",
        srcMenu: "literarte-text-editor-src-menu",
        srcButton: "literarte-text-editor-src-button",

        iconSize: " fa-md"
      }
    };
  }

  toggleBoldButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "bold");

    this.setState(prevState => ({ bold: !prevState.bold }));
  }

  toggleItalicButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "italic");

    this.setState(prevState => ({ italic: !prevState.italic }));
  }

  toggleUnderlineButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "underline");

    this.setState(prevState => ({ underline: !prevState.underline }));
  }

  getText(content) {
    let text = "";
    let leafs = content;

    leafs.forEach((leaf, index, arr) => {
      if (leaf.type === "paragraph") {
        leaf.children.forEach(object => {
          text += object.text;
        });
      }

      if (arr.length - 1 > index) {
        text += " ";
      }
    });

    return text;
  }

  getChars(text) {
    return text.length;
  }

  getWords(text) {
    return text
      .trim()
      .split(/\s+/)
      .filter(n => n !== "").length;
  }

  render() {
    const text = this.getText(this.props.value);
    return (
      <>
        <div
          className={`${this.state.componentStyle.container} w-100 p-0 py-2 justify-content-between`}
        >
          <div className={this.state.componentStyle.formattingMenu}>
            <button
              id={
                this.state.bold
                  ? "literarte-formatting-button-active"
                  : "literarte-formatting-button-inactive"
              }
              className={this.state.componentStyle.formattingButton}
              onClick={e => this.toggleBoldButton(e)}
              onKeyPress={e => this.toggleBoldButton(e)}
            >
              <i
                className={`fa fa-bold${this.state.componentStyle.iconSize}`}
              ></i>
            </button>

            <button
              id={
                this.state.italic
                  ? "literarte-formatting-button-active"
                  : "literarte-formatting-button-inactive"
              }
              className={this.state.componentStyle.formattingButton}
              onClick={e => this.toggleItalicButton(e)}
              onKeyPress={e => this.toggleItalicButton(e)}
            >
              <i
                className={`fa fa-italic${this.state.componentStyle.iconSize}`}
              ></i>
            </button>
            <button
              id={
                this.state.underline
                  ? "literarte-formatting-button-active"
                  : "literarte-formatting-button-inactive"
              }
              className={this.state.componentStyle.formattingButton}
              onClick={e => this.toggleUnderlineButton(e)}
              onKeyPress={e => this.toggleUnderlineButton(e)}
            >
              <i
                className={`fa fa-underline${this.state.componentStyle.iconSize}`}
              ></i>
            </button>
            <button
              className={this.state.componentStyle.srcButton}
              onClick={() => this.props.showImageImporter()}
              onKeyPress={() => this.props.showImageImporter()}
            >
              <i
                className={`fa fa-image${this.state.componentStyle.iconSize}`}
              ></i>
            </button>
          </div>
          <div className="d-flex align-items-center text-muted">
            Palavras: {this.getWords(text)}, Caracteres: {this.getChars(text)}
          </div>
          {/* <div className={this.state.componentStyle.srcMenu}>
          </div>
          <div className={this.state.componentStyle.srcMenu}>
            <button
              className={this.state.componentStyle.srcButton}
              onClick={() => this.props.saveText()}
              onKeyPress={() => this.props.saveText()}
            >
              <i className={`fa fa-floppy-o${this.state.componentStyle.iconSize}`}></i>
            </button>
    </div> */}
        </div>
        <div className="w-100 mb-3 p-0">
          <hr style={{ borderColor: "rgba(0, 0, 0, 0.05)", margin: 0 }} />
        </div>
      </>
    );
  }
}

export default TextEditorFunctionsMenu;
